module.exports = __webpack_public_path__ + "img/main-gallery1.694e0879.jpg";